"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllPoolInfoResponse = exports.QueryAllPoolInfoRequest = exports.QueryPoolInfoResponse = exports.QueryPoolInfoRequest = exports.QueryAllPoolAddressResponse_AddressesEntry = exports.QueryAllPoolAddressResponse = exports.QueryAllPoolAddressRequest = exports.QueryPoolMappingsResponse_PoolMappingsEntry = exports.QueryPoolMappingsResponse = exports.QueryPoolMappingsRequest = exports.QueryAllPoolsResponse = exports.QueryAllPoolsRequest = exports.QueryGetPoolResponse = exports.QueryGetPoolRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryAllPoolMarketLiquidityUsageMultiplierResponse = exports.QueryAllPoolMarketLiquidityUsageMultiplierRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const params_1 = require("./params");
const pool_1 = require("./pool");
const market_1 = require("./market");
exports.protobufPackage = "Switcheo.carbon.perpspool";
const baseQueryAllPoolMarketLiquidityUsageMultiplierRequest = {};
exports.QueryAllPoolMarketLiquidityUsageMultiplierRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolMarketLiquidityUsageMultiplierResponse = {};
exports.QueryAllPoolMarketLiquidityUsageMultiplierResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.marketsLiquidityUsageMultiplier) {
            market_1.MarketLiquidityUsageMultiplier.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierResponse);
        message.marketsLiquidityUsageMultiplier = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketsLiquidityUsageMultiplier.push(market_1.MarketLiquidityUsageMultiplier.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierResponse);
        message.marketsLiquidityUsageMultiplier = ((_a = object.marketsLiquidityUsageMultiplier) !== null && _a !== void 0 ? _a : []).map((e) => market_1.MarketLiquidityUsageMultiplier.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.marketsLiquidityUsageMultiplier) {
            obj.marketsLiquidityUsageMultiplier =
                message.marketsLiquidityUsageMultiplier.map((e) => e ? market_1.MarketLiquidityUsageMultiplier.toJSON(e) : undefined);
        }
        else {
            obj.marketsLiquidityUsageMultiplier = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolMarketLiquidityUsageMultiplierResponse);
        message.marketsLiquidityUsageMultiplier = ((_a = object.marketsLiquidityUsageMultiplier) !== null && _a !== void 0 ? _a : []).map((e) => market_1.MarketLiquidityUsageMultiplier.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryGetPoolRequest = { poolId: "" };
exports.QueryGetPoolRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.poolId !== "") {
            writer.uint32(10).string(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetPoolRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetPoolRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? String(object.poolId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined && (obj.poolId = message.poolId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetPoolRequest);
        message.poolId = (_a = object.poolId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryGetPoolResponse = {};
exports.QueryGetPoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            pool_1.PoolDetails.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = pool_1.PoolDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetPoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.PoolDetails.fromJSON(object.pool)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? pool_1.PoolDetails.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetPoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.PoolDetails.fromPartial(object.pool)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolsRequest = {};
exports.QueryAllPoolsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolsResponse = {};
exports.QueryAllPoolsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pools) {
            pool_1.PoolDetails.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolsResponse);
        message.pools = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pools.push(pool_1.PoolDetails.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolsResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => pool_1.PoolDetails.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pools) {
            obj.pools = message.pools.map((e) => e ? pool_1.PoolDetails.toJSON(e) : undefined);
        }
        else {
            obj.pools = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolsResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => pool_1.PoolDetails.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryPoolMappingsRequest = {};
exports.QueryPoolMappingsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPoolMappingsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPoolMappingsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryPoolMappingsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryPoolMappingsResponse = {};
exports.QueryPoolMappingsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.poolMappings).forEach(([key, value]) => {
            exports.QueryPoolMappingsResponse_PoolMappingsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPoolMappingsResponse);
        message.poolMappings = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryPoolMappingsResponse_PoolMappingsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.poolMappings[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryPoolMappingsResponse);
        message.poolMappings = Object.entries((_a = object.poolMappings) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = long_1.default.fromString(value);
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.poolMappings = {};
        if (message.poolMappings) {
            Object.entries(message.poolMappings).forEach(([k, v]) => {
                obj.poolMappings[k] = v.toString();
            });
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryPoolMappingsResponse);
        message.poolMappings = Object.entries((_a = object.poolMappings) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = long_1.default.fromValue(value);
            }
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryPoolMappingsResponse_PoolMappingsEntry = {
    key: "",
    value: long_1.default.UZERO,
};
exports.QueryPoolMappingsResponse_PoolMappingsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (!message.value.isZero()) {
            writer.uint32(16).uint64(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPoolMappingsResponse_PoolMappingsEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPoolMappingsResponse_PoolMappingsEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? long_1.default.fromString(object.value)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = (message.value || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryPoolMappingsResponse_PoolMappingsEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? long_1.default.fromValue(object.value)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryAllPoolAddressRequest = {};
exports.QueryAllPoolAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolAddressResponse = {};
exports.QueryAllPoolAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.addresses).forEach(([key, value]) => {
            exports.QueryAllPoolAddressResponse_AddressesEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryAllPoolAddressResponse_AddressesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.addresses[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.addresses = {};
        if (message.addresses) {
            Object.entries(message.addresses).forEach(([k, v]) => {
                obj.addresses[k] = v;
            });
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolAddressResponse_AddressesEntry = {
    key: "",
    value: "",
};
exports.QueryAllPoolAddressResponse_AddressesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? String(object.value)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryPoolInfoRequest = { poolId: "" };
exports.QueryPoolInfoRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.poolId !== "") {
            writer.uint32(10).string(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPoolInfoRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPoolInfoRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? String(object.poolId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined && (obj.poolId = message.poolId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryPoolInfoRequest);
        message.poolId = (_a = object.poolId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryPoolInfoResponse = {
    poolId: long_1.default.UZERO,
    totalShareAmount: "",
    totalNavAmount: "",
    availableAmount: "",
    totalInPositionAmount: "",
    totalUpnlAmount: "",
};
exports.QueryPoolInfoResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.totalShareAmount !== "") {
            writer.uint32(18).string(message.totalShareAmount);
        }
        if (message.totalNavAmount !== "") {
            writer.uint32(26).string(message.totalNavAmount);
        }
        if (message.availableAmount !== "") {
            writer.uint32(34).string(message.availableAmount);
        }
        if (message.totalInPositionAmount !== "") {
            writer.uint32(42).string(message.totalInPositionAmount);
        }
        if (message.totalUpnlAmount !== "") {
            writer.uint32(50).string(message.totalUpnlAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPoolInfoResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.totalShareAmount = reader.string();
                    break;
                case 3:
                    message.totalNavAmount = reader.string();
                    break;
                case 4:
                    message.availableAmount = reader.string();
                    break;
                case 5:
                    message.totalInPositionAmount = reader.string();
                    break;
                case 6:
                    message.totalUpnlAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPoolInfoResponse);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.totalShareAmount =
            object.totalShareAmount !== undefined && object.totalShareAmount !== null
                ? String(object.totalShareAmount)
                : "";
        message.totalNavAmount =
            object.totalNavAmount !== undefined && object.totalNavAmount !== null
                ? String(object.totalNavAmount)
                : "";
        message.availableAmount =
            object.availableAmount !== undefined && object.availableAmount !== null
                ? String(object.availableAmount)
                : "";
        message.totalInPositionAmount =
            object.totalInPositionAmount !== undefined &&
                object.totalInPositionAmount !== null
                ? String(object.totalInPositionAmount)
                : "";
        message.totalUpnlAmount =
            object.totalUpnlAmount !== undefined && object.totalUpnlAmount !== null
                ? String(object.totalUpnlAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.totalShareAmount !== undefined &&
            (obj.totalShareAmount = message.totalShareAmount);
        message.totalNavAmount !== undefined &&
            (obj.totalNavAmount = message.totalNavAmount);
        message.availableAmount !== undefined &&
            (obj.availableAmount = message.availableAmount);
        message.totalInPositionAmount !== undefined &&
            (obj.totalInPositionAmount = message.totalInPositionAmount);
        message.totalUpnlAmount !== undefined &&
            (obj.totalUpnlAmount = message.totalUpnlAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseQueryPoolInfoResponse);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.totalShareAmount = (_a = object.totalShareAmount) !== null && _a !== void 0 ? _a : "";
        message.totalNavAmount = (_b = object.totalNavAmount) !== null && _b !== void 0 ? _b : "";
        message.availableAmount = (_c = object.availableAmount) !== null && _c !== void 0 ? _c : "";
        message.totalInPositionAmount = (_d = object.totalInPositionAmount) !== null && _d !== void 0 ? _d : "";
        message.totalUpnlAmount = (_e = object.totalUpnlAmount) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseQueryAllPoolInfoRequest = {};
exports.QueryAllPoolInfoRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolInfoRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolInfoRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolInfoRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolInfoResponse = {};
exports.QueryAllPoolInfoResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pools) {
            exports.QueryPoolInfoResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolInfoResponse);
        message.pools = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pools.push(exports.QueryPoolInfoResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolInfoResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.QueryPoolInfoResponse.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pools) {
            obj.pools = message.pools.map((e) => e ? exports.QueryPoolInfoResponse.toJSON(e) : undefined);
        }
        else {
            obj.pools = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolInfoResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.QueryPoolInfoResponse.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.PoolInfo = this.PoolInfo.bind(this);
        this.PoolInfoAll = this.PoolInfoAll.bind(this);
        this.PoolAddressAll = this.PoolAddressAll.bind(this);
        this.PoolMarketLiquidityUsageMultiplierAll =
            this.PoolMarketLiquidityUsageMultiplierAll.bind(this);
        this.Pool = this.Pool.bind(this);
        this.PoolAll = this.PoolAll.bind(this);
        this.PoolMappings = this.PoolMappings.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolInfo(request) {
        const data = exports.QueryPoolInfoRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolInfo", data);
        return promise.then((data) => exports.QueryPoolInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolInfoAll(request) {
        const data = exports.QueryAllPoolInfoRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolInfoAll", data);
        return promise.then((data) => exports.QueryAllPoolInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolAddressAll(request) {
        const data = exports.QueryAllPoolAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolAddressAll", data);
        return promise.then((data) => exports.QueryAllPoolAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolMarketLiquidityUsageMultiplierAll(request) {
        const data = exports.QueryAllPoolMarketLiquidityUsageMultiplierRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolMarketLiquidityUsageMultiplierAll", data);
        return promise.then((data) => exports.QueryAllPoolMarketLiquidityUsageMultiplierResponse.decode(new minimal_1.default.Reader(data)));
    }
    Pool(request) {
        const data = exports.QueryGetPoolRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "Pool", data);
        return promise.then((data) => exports.QueryGetPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolAll(request) {
        const data = exports.QueryAllPoolsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolAll", data);
        return promise.then((data) => exports.QueryAllPoolsResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolMappings(request) {
        const data = exports.QueryPoolMappingsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Query", "PoolMappings", data);
        return promise.then((data) => exports.QueryPoolMappingsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
